import React from 'react';
// reactstrap components
import { Col, Row } from 'reactstrap';

import ForgotPasswordForm from './forgotPasswordForm.jsx';
import ForgotPasswordMessage from './forgotPasswordMessage.jsx';

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewForm: true,
      responseMessage: '',
    };
    this.requestPassword = this.requestPassword.bind(this);
  }

  handleChange = async (event) => {
    const { target } = event;
    const value = target.value;
    const { name } = target;
    await this.setState({
      [name]: value,
    });
    if (name === 'email') {
      this.validateEmail(target);
    }
    if (name === 'password') {
      this.validatePassword(target);
    }
  };

  componentDidUpdate() {
    if (this.props.message === 'true' && this.state.viewForm === true) {
      this.setState({ viewForm: false });
    }
  }

  async requestPassword(email) {
    await this.props.requestPassword(email);
    this.setState({ responseMessage: this.props.message });
  }

  render() {
    const content = () => {
      if (this.state.viewForm) {
        return (
          <ForgotPasswordForm
            requestPassword={this.requestPassword}
            message={this.props.message}
            successful={this.props.successful}
            errors={this.props.errors}
            setMessage={this.props.setMessage}
          />
        );
      }
      return (
        <ForgotPasswordMessage
          successfull={this.props.successful}
          message={this.props.message}
          setMessage={this.props.setMessage}
        />
      );
    };
    return (
      <div>
        <div className="login-container text-center">
          <Row className="p-0 m-0 lala">
            {/* image */}
            <Col md={6} className="d-none d-md-block p-0 login-image-container">
              <h1>The only tool for the USAF-wide PFE/SKT exam.</h1>
            </Col>

            {/* form */}

            <Col xs={12} md={6} className="login-form-container">
              {content()}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

// Login.propTypes = {
//   handleSubmit: PropTypes.func,
//   message: PropTypes.string,
// };

export default ForgotPassword;
